/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import PropTypes from 'prop-types';

export const PromotionsTypeEnum = {
    MIX_AND_MATCH: 'MIX_AND_MATCH',
    OPTIONAL_BUNDLE: 'OPTIONAL_BUNDLE',
    MANDATORY_BUNDLE: 'MANDATORY_BUNDLE',
    DEFAULT: null
};

export const SKUPromotion = {
    id: PropTypes.string,
    type: PropTypes.string,
    promoCode: PropTypes.string,
    shortPromoText: PropTypes.string,
    longPromoText: PropTypes.string,
    reduction: PropTypes.string,
    reductionDouble: PropTypes.number,
    threshold: PropTypes.number,
    activated: PropTypes.bool,
    thresholdNotReachedText: PropTypes.string,
};

export const SKU = {
    aemProdLongDescription: PropTypes.string,
    aemProdName:  PropTypes.string,
    aemProdShortDescription:  PropTypes.string,
    baseUnit:  PropTypes.string,
    contractNumber: PropTypes.string,
    currency:  PropTypes.string,
    hasContract:  PropTypes.bool,
    hasPrice: PropTypes.bool,
    imageUrl:  PropTypes.string,
    isObsolete:  PropTypes.bool,
    longPromoText:  PropTypes.string,
    materialDescription:  PropTypes.string,
    materialNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    materialSalesText:  PropTypes.string,
    minimumOrderableQuantity: PropTypes.number,
    packaging:  PropTypes.string,
    promotion: PropTypes.shape(SKUPromotion),
    promoCode:  PropTypes.string,
    promoText:  PropTypes.string,
    promotionTotalPrice:  PropTypes.string,
    promotionTotalPriceDouble:  PropTypes.number,
    promotionUnitPrice:  PropTypes.string,
    promotionUnitPriceDouble:  PropTypes.number,
    promotionWeightPrice:  PropTypes.string,
    promotionWeightPriceDouble:  PropTypes.number,
    salesUnit:  PropTypes.string,
    shortPromoText:  PropTypes.string,
    skuImageUrl:  PropTypes.string,
    totalUnitPrice:  PropTypes.string,
    unitPrice:  PropTypes.string,
    weightPrice:  PropTypes.string,
    withContract: PropTypes.bool
};
